import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatJobTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatJobType',
})
export class FormatJobTypePipe implements PipeTransform {
  /**
   * Takes a job's jobTypeSelect value and displays in a human-readable format
   */
  transform(value: string, ...args) {
    let jobTypes = {
      otr: 'Over the Road',
      regional: 'Regional',
      dedicatedlane: 'Dedicated Lane',
      dedicatedaccount: 'Dedicated Account',
      local: 'Local',
      'non-driving': 'Non-Driving',
    };
    return jobTypes[value] || 'Call to Discuss';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-job-type/format-job-type.ts